import api from '../../api';

export default {
    namespaced: true,
    state: {
        orgs: [],
        partners: [],
    },
    getters: {
        orgs(state) {
            return state.orgs;
        },
        org: (state) => (orgId) => {
            return state.orgs.find((org) => org.id === orgId);
        },
        partners(state) {
            return state.partners;
        },
        partner: (state) => (partnerId) => {
            return state.partners.find((partner) => partner.id === partnerId);
        },
    },
    mutations: {
        orgs(state, orgs) {
            state.orgs = orgs;
        },
        partners(state, partners) {
            state.partners = partners;
        },
    },
    actions: {
        async loadOrgs({ commit }) {
            commit('orgs', await api.get('admin/organizations'));
        },
        async updateOrg({ getters, commit }, org) {
            const { updatedAt } = await api.put(`admin/organizations/${org.id}`, org);
            org.updated_at = updatedAt;
            const newOrgs = getters.orgs.slice();
            const index = newOrgs.findIndex((o) => o.id === org.id);
            newOrgs.splice(index, 1, org);
            commit('orgs', newOrgs);
        },
        async loadPartners({ commit }) {
            commit('partners', await api.get('admin/partners'));
        },
        async updatePartner({ getters, commit }, partner) {
            const { updatedAt } = await api.put(`admin/partners/${partner.id}`, partner);
            partner.updated_at = updatedAt;
            const newPartners = getters.partners.slice();
            const index = newPartners.findIndex((p) => p.id === partner.id);
            newPartners.splice(index, 1, partner);
            commit('partners', newPartners);
        },
        async loginToOrg({ rootGetters }, orgId) {
            await api.post(`admin/organizations/${orgId}/login`);
            window.location = rootGetters['base/url'];
        },
        async logoutOfOrg({ rootGetters }) {
            const orgId = rootGetters['org/org'].id;
            await api.post(`admin/organizations/${orgId}/logout`);
            window.location = `${rootGetters['base/url']}/admin/organizations/${orgId}`;
        },
    }
}